export const phoneFormats = {
  BRA: {
    pattern: [2, 5, 4],
    formatter: ([a, b, c]) =>
      c ? `(${a}) ${b}-${c}` : b ? `(${a}) ${b}` : a ? `(${a}` : "",
  },
  USA: {
    pattern: [3, 3, 4],
    formatter: ([a, b, c]) =>
      c ? `(${a}) ${b}-${c}` : b ? `(${a}) ${b}` : a ? `(${a}` : "",
  },
  ESP: {
    pattern: [3, 3, 3],
    formatter: ([a, b, c]) =>
      c ? `${a} ${b} ${c}` : b ? `${a} ${b}` : a ? `${a}` : "",
  },

  default: {
    pattern: [],
    formatter: ([a]) => a || "",
  },
};

export function formatPhone(value = "", country = "BRA") {
  const { pattern, formatter } = phoneFormats[country] || phoneFormats.default;
  const digits = value.replace(/\D/g, "");

  if (!pattern || pattern.length === 0) {
    return digits;
  }

  const parts = [];
  let idx = 0;
  for (const len of pattern) {
    parts.push(digits.slice(idx, idx + len));
    idx += len;
  }

  return formatter(parts);
}
